import { Divider, Popover } from '@mui/material'
import { NoData } from '@components/noData'
import { SearchColumns } from './components/search-columns'
import { PopoverProps } from './types'

export function PopoverWithSearch({
  anchorEl,
  handleOnClose,
  children,
  searchTerm,
  handleSearch,
  handleClearSearch,
  noSearchResults,
  contentStyle,
  noDataMessage = "We couldn't find any columns matching your search",
  headerSlot,
  ...otherProps
}: PopoverProps) {
  return (
    <Popover
      elevation={0}
      PaperProps={{ elevation: 0 }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      disableRestoreFocus
      onClose={handleOnClose}
      {...otherProps}
    >
      {headerSlot}
      <div style={contentStyle}>
        <SearchColumns
          searchTerm={searchTerm}
          handleSearch={handleSearch}
          handleClearSearch={handleClearSearch}
        />
        {noSearchResults ? (
          <div>
            <Divider />
            <NoData
              text={{
                body: {
                  mainText: noDataMessage,
                },
              }}
            />
          </div>
        ) : (
          children
        )}
      </div>
    </Popover>
  )
}
